export default function Diamond() {
  return (
    <div className="diamond">
      <div className="diamond__inner" />
    </div>
  );
}
